import { useMemo } from 'react';
import { EntityOption, UseEntityOptionsProps } from './useEntityOptions.props';

export const useEntityOptions = ({ companyInfo }: UseEntityOptionsProps): EntityOption[] => useMemo(() => {
  const options: EntityOption[] = [];

  // Add the primary company
  if (companyInfo?.id && companyInfo?.name) {
    options.push({
      id: `company-${companyInfo.id}`,
      value: `company-${companyInfo.id}`,
      label: companyInfo.name,
      type: 'company',
    });
  }

  // Add child companies
  if (companyInfo?.child_companies) {
    const childCompanyOptions = companyInfo.child_companies.map((child: any) => ({
      id: `company-${child.company_id}`,
      value: `company-${child.company_id}`,
      label: child.company_name,
      type: 'company' as const,
    }));
    options.push(...childCompanyOptions);
  }

  return options;
}, [companyInfo]);
